var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gj-select',_vm._g(_vm._b({attrs:{"options":_vm.countryOptions,"placeholder":_vm.placeholder,"clearable":_vm.clearable,"type":_vm.multiple ? 'multi-check' : 'default',"width":_vm.width}},'gj-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }